import React, { useContext, useState } from 'react';
import Placeholder from '../Assets/Icons/Placeholder.png';
import UI_Button from './ERUMAUI/UI_Button'; 
import Icon_Logout from '../Assets/Icons/Icon_Logout.png';
import Icon_LightMode from '../Assets/Icons/Icon_LightMode.png';
import Icon_DarkMode from '../Assets/Icons/Icon_DarkMode.png';
import Icon_Animation from '../Assets/Icons/Icon_Animation.png';
import Icon_User from '../Assets/Icons/Icon_User.png';
import { Context_UI } from '../Contexts/Context_UI';
import { useAuth } from '../Contexts/AuthContext';

export default function Overlay_Header_Account() {
    const { Account, Loading } = useAuth();
    const [ColorMode_Inverse, ColorMode_Inverse_Set] = useState("Dark mode");
    const [ColorMode_Inverse_Icon, ColorMode_Inverse_Icon_Set] = useState(Icon_DarkMode);
    const [SmoothMode_Inverse, SmoothMode_Inverse_Set] = useState("Transitions");
    const UI = useContext(Context_UI);
    const SignOut = () => {
        localStorage.removeItem("Token");
        UI.Element_Attribute_Set("Overlay_Header", "State", "Inactive");
        UI.Page_ChangePage("/");
    }
    const SwitchToUser = () => {
        UI.Element_Attribute_Set("Overlay_Header", "State", "Inactive");
        UI.Page_ChangePage("/user");
    }
    const ColorMode_Toggle = () => {
        if (UI.Element_Attribute_Get("body", "Theme") == "Light") {
            UI.Element_Attribute_Set("body", "Theme", "Dark");
            let Configuration = { Mode: "Dark" };
            localStorage.setItem("DR_Mode", JSON.stringify(Configuration));
            ColorMode_Inverse_Set("Light mode");
            ColorMode_Inverse_Icon_Set(Icon_LightMode);
        } else {
            UI.Element_Attribute_Set("body", "Theme", "Light");
            ColorMode_Inverse_Set("Dark mode");
            ColorMode_Inverse_Icon_Set(Icon_DarkMode);
            let Configuration = { Mode: "Light" };
            localStorage.setItem("DR_Mode", JSON.stringify(Configuration));
        }
    }
    const Smooth_Toggle = () => {
        if (UI.Element_Attribute_Get("body", "Smooth") == "true") {
            UI.Element_Attribute_Set("body", "Smooth", "false");
            let Configuration = { Mode: "false" };
            localStorage.setItem("DR_Mode_Smooth", JSON.stringify(Configuration));
            SmoothMode_Inverse_Set("Transitions");
        } else {
            UI.Element_Attribute_Set("body", "Smooth", "true");
            SmoothMode_Inverse_Set("Snappy");
            let Configuration = { Mode: "Light" };
            localStorage.setItem("DR_Mode_Smooth", JSON.stringify(Configuration));
        }
    }
    return (
        <div className="Overlay_Header" id='Overlay_Header' State="Inactive">
            <div className='Overlay_Header_Content'>
                <div className='Overlay_Header_Main'>
                    <h3 className='Overlay_Header_Name'>
                        {Account?.Name_Compounded}
                    </h3>
                    <p className='Overlay_Header_Email'>
                        {Account?.Email}
                    </p>
                </div>
                <div className='Overlay_Header_Controls'>
                    {/* <UI_Button Icon={ColorMode_Inverse_Icon} Icon_Position="Center" Text={ColorMode_Inverse} OnClick={ColorMode_Toggle}/>
                    <UI_Button Icon={Icon_Animation} Icon_Position="Center" Text={SmoothMode_Inverse} OnClick={Smooth_Toggle}/> */}
                    <UI_Button Icon={Icon_User} Icon_Position="Center" Text="Your account" OnClick={SwitchToUser}/>
                    <UI_Button Icon={Icon_Logout} Icon_Position="Center" Text="Sign out" OnClick={SignOut}/>
                </div>
                <p className='General_Paragraph' style={{padding: "10px", opacity: "50%", fontSize: "small"}}>
                    NSDAPS Digi-Rooms Beta 1.1 | January 2026
                </p>
            </div>
        </div>
    );
}
